import src from "IMAGE";
export default { src, width: 2072, height: 897, blurWidth: 0, blurHeight: 0};
